import { FC, ReactElement, memo } from 'react';
import { IMenuProduct } from '~/types/products';
import { formatUnit } from '~/utils/formatter';
import './style.scss';

interface IProps {
  product: IMenuProduct;
}

export const OrderCartProductUnit: FC<IProps> = memo(({ product }: IProps): ReactElement | null => {
  const unit: string | null = product.size ? formatUnit(product.size.unit_name, product.size.weight) : formatUnit(product.unit_name, product.weight);

  if (!unit) return null;

  return <p className="order-cart-product-unit">{unit}</p>;
});
